// Revolutionary Spirits & Freedom Fighters Data - Group Three (Third 6 Characters)

// Spartacus's workout programs
const spartacusPrograms = [
    {
        id: 'gladiator-arena-conditioning',
        name: 'Gladiator Arena Conditioning',
        description: 'Life-or-death combat training that transforms slaves into unbreakable warriors',
        pattern: '>$x&*+',
        reps: 73,
        sets: 3,
        focus: 'Combat Survival'
    },
    {
        id: 'break-chains-strength-training',
        name: 'Break Chains Strength Training',
        description: 'Raw power conditioning that shatters the bonds of oppression through pure strength',
        pattern: '*&x$>+',
        reps: 71,
        sets: 4,
        focus: 'Chain Breaking Power'
    },
    {
        id: 'third-servile-war-workout',
        name: 'Third Servile War Workout',
        description: 'Revolutionary leadership training that unites diverse fighters against impossible odds',
        pattern: '+>*$x&',
        reps: 200,
        sets: 3,
        focus: 'Revolutionary Unity'
    },
    {
        id: 'mount-vesuvius-endurance',
        name: 'Mount Vesuvius Endurance',
        description: 'Volcanic strength training that erupts from the mountainous stronghold of rebellion',
        pattern: 'x&+>$*',
        reps: 39,
        sets: 5,
        focus: 'Volcanic Endurance'
    },
    {
        id: 'slave-rebellion-protocol',
        name: 'Slave Rebellion Protocol',
        description: 'Liberation conditioning that inspires the oppressed to rise up and fight for freedom',
        pattern: '&*+x$>',
        reps: 120,
        sets: 5,
        focus: 'Liberation Inspiration'
    },
    {
        id: 'rebel-gladiator-mastery',
        name: 'Rebel Gladiator Mastery',
        description: 'The complete training system that turned a slave into history\'s greatest freedom fighter',
        pattern: '>$x&*+!',
        reps: 71,
        sets: 3,
        focus: 'Freedom Fighter Legend'
    }
];

// Boudica's workout programs
const boudicaPrograms = [
    {
        id: 'iceni-warrior-queen-training',
        name: 'Iceni Warrior Queen Training',
        description: 'Celtic royal conditioning that channels maternal fury into unstoppable warrior rage',
        pattern: '[]{}<:',
        reps: 60,
        sets: 4,
        focus: 'Royal Fury'
    },
    {
        id: 'roman-revenge-conditioning',
        name: 'Roman Revenge Conditioning',
        description: 'Vengeance-driven training that destroys legions and burns cities to the ground',
        pattern: ':<{}[]',
        reps: 70,
        sets: 9,
        focus: 'Vengeful Destruction'
    },
    {
        id: 'chariot-warfare-workout',
        name: 'Chariot Warfare Workout',
        description: 'High-speed combat training with scythed wheels that cuts through enemy formations',
        pattern: '{}[]<:',
        reps: 45,
        sets: 5,
        focus: 'Chariot Combat'
    },
    {
        id: 'celtic-tribal-unity-protocol',
        name: 'Celtic Tribal Unity Protocol',
        description: 'Unification training that rallies scattered tribes into one mighty war machine',
        pattern: '<:{}[]',
        reps: 48,
        sets: 4,
        focus: 'Tribal Unity'
    },
    {
        id: 'londinium-siege-training',
        name: 'Londinium Siege Training',
        description: 'City-burning conditioning that reduces Roman strongholds to ash and memory',
        pattern: '[]<:{',
        reps: 61,
        sets: 3,
        focus: 'City Destruction'
    },
    {
        id: 'queen-of-vengeance-mastery',
        name: 'Queen of Vengeance Mastery',
        description: 'The complete training of the Celtic queen who almost drove Rome from Britain',
        pattern: '[]{}<:!',
        reps: 60,
        sets: 3,
        focus: 'Vengeance Queen'
    }
];

// King Leonidas's workout programs
const kingLeonidasPrograms = [
    {
        id: 'spartan-three-hundred-training',
        name: 'Spartan Three Hundred Training',
        description: 'Elite warrior conditioning for those chosen to stand against impossible odds',
        pattern: 'p:;}|<',
        reps: 300,
        sets: 2,
        focus: 'Elite Warrior'
    },
    {
        id: 'thermopylae-last-stand-conditioning',
        name: 'Thermopylae Last Stand Conditioning',
        description: 'Final battle training that holds narrow passes against overwhelming enemy forces',
        pattern: ';}|<p:',
        reps: 3,
        sets: 100,
        focus: 'Last Stand Defense'
    },
    {
        id: 'this-is-sparta-workout',
        name: 'This Is Sparta Workout',
        description: 'Signature strength training that defines Spartan warrior culture and unwavering resolve',
        pattern: '|<p:;}',
        reps: 160,
        sets: 3,
        focus: 'Spartan Identity'
    },
    {
        id: 'persian-empire-defiance-protocol',
        name: 'Persian Empire Defiance Protocol',
        description: 'Anti-imperial training that refuses to bow to the greatest empire on earth',
        pattern: '<p:;|}',
        reps: 42,
        sets: 4,
        focus: 'Empire Defiance'
    },
    {
        id: 'molon-labe-training',
        name: 'Molon Labe Training',
        description: 'Come and take them conditioning - the ultimate expression of Spartan defiance',
        pattern: ':;}|<p',
        reps: 160,
        sets: 3,
        focus: 'Defiant Challenge'
    },
    {
        id: 'spartan-king-mastery',
        name: 'Spartan King Mastery',
        description: 'The complete training system of the warrior-king who chose beautiful death over shameful life',
        pattern: 'p:;}|<!',
        reps: 300,
        sets: 2,
        focus: 'Beautiful Death'
    }
];

// Theodore Roosevelt's workout programs
const theodoreRooseveltPrograms = [
    {
        id: 'rough-rider-conditioning',
        name: 'Rough Rider Conditioning',
        description: 'Cavalry charge training that storms up San Juan Hill with unstoppable American vigor',
        pattern: 'qnuvyg',
        reps: 26,
        sets: 4,
        focus: 'Cavalry Vigor'
    },
    {
        id: 'big-stick-diplomacy-workout',
        name: 'Big Stick Diplomacy Workout',
        description: 'Speak softly but carry the strength to back up every word with decisive action',
        pattern: 'vygqnu',
        reps: 95,
        sets: 2,
        focus: 'Diplomatic Strength'
    },
    {
        id: 'strenuous-life-training',
        name: 'Strenuous Life Training',
        description: 'Anti-soft living conditioning that builds character through constant physical challenge',
        pattern: 'gyunvq',
        reps: 34,
        sets: 5,
        focus: 'Strenuous Character'
    },
    {
        id: 'trust-buster-protocol',
        name: 'Trust Buster Protocol',
        description: 'Monopoly-breaking training that takes on corporate giants with presidential power',
        pattern: 'nvqgyu',
        reps: 44,
        sets: 4,
        focus: 'Corporate Breaking'
    },
    {
        id: 'conservation-president-training',
        name: 'Conservation President Training',
        description: 'Natural preservation conditioning that protects wilderness for future generations',
        pattern: 'qyuvng',
        reps: 230,
        sets: 3,
        focus: 'Wilderness Protection'
    },
    {
        id: 'bully-pulpit-mastery',
        name: 'Bully Pulpit Mastery',
        description: 'The complete training of America\'s most energetic president who redefined executive power',
        pattern: 'qnuvyg!',
        reps: 60,
        sets: 3,
        focus: 'Executive Energy'
    }
];

// Che Guevara's workout programs
const cheGuevaraPrograms = [
    {
        id: 'guerrilla-warfare-conditioning',
        name: 'Guerrilla Warfare Conditioning',
        description: 'Jungle revolutionary training that defeats regular armies through mobility and conviction',
        pattern: 'hnmkyt',
        reps: 26,
        sets: 7,
        focus: 'Guerrilla Mobility'
    },
    {
        id: 'cuban-revolution-training',
        name: 'Cuban Revolution Training',
        description: 'Island liberation conditioning that overthrows dictatorships with revolutionary fire',
        pattern: 'ytmknh',
        reps: 65,
        sets: 3,
        focus: 'Revolutionary Fire'
    },
    {
        id: 'motorcycle-diaries-workout',
        name: 'Motorcycle Diaries Workout',
        description: 'Continental awakening training that transforms medical students into revolutionary leaders',
        pattern: 'knhytm',
        reps: 133,
        sets: 6,
        focus: 'Revolutionary Awakening'
    },
    {
        id: 'hasta-la-victoria-protocol',
        name: 'Hasta La Victoria Protocol',
        description: 'Until victory conditioning that never accepts defeat in the struggle for justice',
        pattern: 'myhtnk',
        reps: 39,
        sets: 4,
        focus: 'Victory Persistence'
    },
    {
        id: 'new-man-training',
        name: 'New Man Training',
        description: 'Socialist consciousness conditioning that creates selfless revolutionary dedication',
        pattern: 'nhkmty',
        reps: 196,
        sets: 1,
        focus: 'Socialist Consciousness'
    },
    {
        id: 'immortal-revolutionary-mastery',
        name: 'Immortal Revolutionary Mastery',
        description: 'The complete training system that creates eternal symbols of revolutionary struggle',
        pattern: 'hnmkyt!',
        reps: 39,
        sets: 3,
        focus: 'Eternal Revolution'
    }
];

// Rasputin's workout programs
const rasputinPrograms = [
    {
        id: 'mad-monk-mystical-training',
        name: 'Mad Monk Mystical Training',
        description: 'Hypnotic conditioning that bends the will of emperors through supernatural charisma',
        pattern: 'wdfaeu',
        reps: 47,
        sets: 4,
        focus: 'Hypnotic Influence'
    },
    {
        id: 'romanov-court-manipulation',
        name: 'Romanov Court Manipulation',
        description: 'Political intrigue training that controls royal families through mystical healing powers',
        pattern: 'eufadw',
        reps: 100,
        sets: 3,
        focus: 'Royal Manipulation'
    },
    {
        id: 'siberian-peasant-endurance',
        name: 'Siberian Peasant Endurance',
        description: 'Frozen wasteland conditioning that builds the unbreakable will of Russian peasants',
        pattern: 'fawdue',
        reps: 186,
        sets: 1,
        focus: 'Siberian Endurance'
    },
    {
        id: 'holy-man-healing-protocol',
        name: 'Holy Man Healing Protocol',
        description: 'Divine intervention training that miraculously heals royal children through faith',
        pattern: 'deufaw',
        reps: 52,
        sets: 3,
        focus: 'Miraculous Healing'
    },
    {
        id: 'unkillable-mystic-training',
        name: 'Unkillable Mystic Training',
        description: 'Supernatural survival conditioning that resists poison, bullets, and drowning',
        pattern: 'uwfade',
        reps: 191,
        sets: 1,
        focus: 'Supernatural Survival'
    },
    {
        id: 'empire-destroyer-mastery',
        name: 'Empire Destroyer Mastery',
        description: 'The complete training system that topples dynasties through mystical corruption',
        pattern: 'wdfaeu!',
        reps: 71,
        sets: 3,
        focus: 'Dynasty Destruction'
    }
];

// Main Revolutionary Spirits & Freedom Fighters trainers data object - Group Three
const historyThreeTrainersData = {
    'spartacus': {
        id: 'spartacus',
        name: 'Spartacus',
        specialization: 'Gladiator Combat & Chain Breaking Strength',
        image: '/assets/images/spartacus.jpg',
        experience: '71+ years',
        category: 'revolutionary-spirits',
        color: '#8B0000',
        secondaryColor: '#000000',
        intro: `The gladiator who broke his chains and led the greatest slave rebellion in history. His training transforms oppression into explosive strength and teaches that true power comes from refusing to accept enslavement. Freedom is won through strength, unity, and the courage to fight impossible odds.`,
        programs: spartacusPrograms
    },
    'boudica': {
        id: 'boudica',
        name: 'Boudica',
        specialization: 'Celtic Warfare & Vengeance Conditioning',
        image: '/assets/images/boudica.jpg',
        experience: '60+ years',
        category: 'revolutionary-spirits',
        color: '#228B22',
        secondaryColor: '#DC143C',
        intro: `The Celtic warrior queen who united the tribes and burned Roman cities to ash. Her training channels maternal fury into unstoppable force and teaches that the greatest strength comes from protecting what you love. Some things are worth more than life itself.`,
        programs: boudicaPrograms
    },
    'king-leonidas': {
        id: 'king-leonidas',
        name: 'King Leonidas',
        specialization: 'Spartan Elite & Last Stand Defense',
        image: '/assets/images/king-leonidas.jpg',
        experience: '60+ years',
        category: 'revolutionary-spirits',
        color: '#DC143C',
        secondaryColor: '#8B0000',
        intro: `The Spartan king who chose beautiful death over shameful life at Thermopylae. His training creates warriors who never retreat and never surrender. True strength is measured not by victories won, but by the courage to stand when all seems lost.`,
        programs: kingLeonidasPrograms
    },
    'theodore-roosevelt': {
        id: 'theodore-roosevelt',
        name: 'Theodore Roosevelt',
        specialization: 'Strenuous Life & Presidential Vigor',
        image: '/assets/images/theodore-roosevelt.jpg',
        experience: '60+ years',
        category: 'revolutionary-spirits',
        color: '#B8860B',
        secondaryColor: '#8B4513',
        intro: `The energetic president who charged up San Juan Hill and transformed American power. His training builds the strenuous character that conquers both wilderness and corporate monopolies. Speak softly, but carry the strength to back up every word.`,
        programs: theodoreRooseveltPrograms
    },
    'che-guevara': {
        id: 'che-guevara',
        name: 'Che Guevara',
        specialization: 'Guerrilla Revolution & Socialist Consciousness',
        image: '/assets/images/che-guevara.jpg',
        experience: '39+ years',
        category: 'revolutionary-spirits',
        color: '#006400',
        secondaryColor: '#DC143C',
        intro: `The eternal revolutionary who transformed from medical student to guerrilla legend. His training develops the mobility and conviction needed to defeat regular armies and create lasting revolutionary change. Until victory, always.`,
        programs: cheGuevaraPrograms
    },
    'rasputin': {
        id: 'rasputin',
        name: 'Rasputin',
        specialization: 'Mystical Influence & Supernatural Endurance',
        image: '/assets/images/rasputin.jpg',
        experience: '71+ years',
        category: 'revolutionary-spirits',
        color: '#4B0082',
        secondaryColor: '#000000',
        intro: `The mad monk whose mystical powers toppled the Romanov dynasty. His training develops supernatural endurance and the hypnotic influence that bends emperors to your will. True power comes from the ability to survive what would destroy ordinary men.`,
        programs: rasputinPrograms
    }
};

// Export the data
export default historyThreeTrainersData;